import { Tooltip } from 'kenshin';
import styles from './index.less';
import iconKpi from '@/_assets/common/icon-kpi.png';
import iconWeekplan from '@/_assets/common/icon-week-plan.png';
import iconReport from '@/_assets/common/icon-report.png';
import iconNewweekplan from '@/_assets/common/icon-add-plan.png';
import iconNewproject from '@/_assets/common/icon-new-project.png';
import iconAddKpi from '@/_assets/common/icon-add-kpi.png';
import iconOvertime from '@/_assets/common/icon-ot.png';
import iconLeave from '@/_assets/common/icon-leave.png';
import iconForgot from '@/_assets/common/icon-forgot.png';
import { history } from 'umi';
import { useEffect, useRef, useState } from 'react';
import { connect } from 'umi';
import { getOsaEdit, getWeekEdit } from '@/_util';

const CommonUse = ({ dispatch }) => {
  const [commonFunctions, setCommonFunctions] = useState([]);

  let OSAEDIT = useRef(getOsaEdit());
  let WEEKEDIT = useRef(getWeekEdit());

  const findIdByProcessOptions = (processOptions, busiName) => {
    return processOptions.find((item) => item.value.includes(busiName))?.id;
  };

  const initCommonFunctions = () => {
    const list = [
      {
        name: '绩效变更',
        icon: iconKpi,
        color: '#4389F9',
        route: `/process/createProcess?processBusiType=${OSAEDIT.current}`,
      },
      {
        name: '周计划变更',
        icon: iconWeekplan,
        color: '#4389F9',
        route: `/process/createProcess?processBusiType=${WEEKEDIT.current}`,
      },
      {
        name: '上报变更',
        icon: iconReport,
        color: '#4389F9',
        route: '/usercenter/workLog',
      },

      {
        name: '新增周计划',
        icon: iconNewweekplan,
        color: '#3FCC7D',
        route: `/performance/assessment/weeklyPlan?muId=${
          JSON.parse(localStorage.getItem('employeeDTO'))?.empId
        }`,
      },
      {
        name: '新建项目',
        icon: iconNewproject,
        color: '#3FCC7D',
        route: '/project/list',
      },
      {
        name: '新建绩效',
        icon: iconAddKpi,
        color: '#3FCC7D',
        route: `/performance/assessment/OSA?muId=${
          JSON.parse(localStorage.getItem('employeeDTO'))?.empId
        }`,
      },

      {
        name: '加班申请',
        icon: iconOvertime,
        color: '#6370DE',
        route: '/attendance/apply/addApply',
      },
      {
        name: '调休申请',
        icon: iconLeave,
        color: '#6370DE',
        route: '/attendance/apply/addApply?applyBusiType=15',
      },
      {
        name: '忘打卡申请',
        icon: iconForgot,
        color: '#6370DE',
        route: '/attendance/apply/addApply?applyBusiType=12',
      },
    ];
    setCommonFunctions(list);
    console.log('commonFunctions...', list);
  };

  const initDataList = (datas) => {
    WEEKEDIT.current = findIdByProcessOptions(datas, '周计划变更') || '9';
    OSAEDIT.current = findIdByProcessOptions(datas, '绩效变更') || '8';
    initCommonFunctions();
  };

  useEffect(() => {
    initCommonFunctions();
    dispatch({
      type: 'process/getsimpprocesslist',
    }).then((res) => {
      if (res) {
        initDataList(res);
      }
    });
  }, []);

  const handleItemClick = (route) => {
    if (route) {
      history.push(route); // v6: navigate(route);
    }
  };

  return (
    <div className={styles.commonUseContainer}>
      <h3 className={styles.title}>常用功能</h3>
      <div className={styles.functionGrid}>
        {commonFunctions.map((item, index) => (
          <div
            key={index}
            className={styles.functionItem}
            onClick={() => handleItemClick(item.route)}
          >
            <Tooltip title={item.name}>
              <div className={styles.iconContainer}>
                <img src={item.icon} alt="" />
              </div>
            </Tooltip>
            <div className={styles.functionName}>{item.name}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

// export default CommonUse;

export default connect(({ process, loading, systemOrgani }) => {
  return {
    process,
    loading: loading.effects,
    systemOrgani,
  };
})(CommonUse);
